export const setUserProfile = (value: any) => {
	return {
		type: 'SET_USER_PROFILE',
		payload: value,
	};
};
